import * as React from "react";
import { styled } from "@mui/material";
import { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import clsx from "clsx";
import { ColorBox } from "./colorBox";
import ClickAwayListener from "@mui/material/ClickAwayListener";

//region [[ Styles ]]

const ClinicThemeColorPickerView = styled("div")({});

const ColorPreview = styled("div")({
  textTransform: "capitalize",
  display: "flex",
  flexFLow: "row",
  alignItems: "center",
  width: "100%",
  justifyContent: "flex-end",
});

const ColorName = styled("div")({
  flex: 1,
});

//endregion [[ Styles ]]

//region [[ Props ]]
export type ReactColor = {
  hex: string;
  rgb?: {
    r: number;
    g: number;
    b: number;
    a: number;
  };
  hsl?: {
    h: number;
    s: number;
    l: number;
    a: number;
  };
};

export interface ClinicThemeColorPickerProps {
  className?: string;
  colorKey: string;
  color: string;
  onColorChange: (ReactColor) => void;
  hideName?: boolean;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicThemeColorPicker = ({
  color,
  colorKey,
  ...props
}: ClinicThemeColorPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentColor, setCurrentColor] = useState(color);

  const handleColorChange = (color: ReactColor) => {
    setCurrentColor(color.hex);
    props.onColorChange(color);
  };

  // Sync state with props
  useEffect(() => {
    setCurrentColor(color);
  }, [color]);

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <ClinicThemeColorPickerView
        className={clsx("clinic-theme-color-picker", props.className)}
      >
        <ColorPreview className={"color-preview-container"}>
          {!props.hideName && (
            <ColorName>{colorKey?.replace?.("--", "")}:</ColorName>
          )}
          <ColorBox
            color={currentColor}
            onChange={(hex) => handleColorChange({ hex })}
            onColorClick={() => setIsOpen((isOpen) => !isOpen)}
            disabled={props.disabled}
          />
        </ColorPreview>

        {isOpen && (
          <SketchPicker color={currentColor} onChange={handleColorChange} />
        )}
      </ClinicThemeColorPickerView>
    </ClickAwayListener>
  );
};
